import { LOGOUT_USER, SET_USER, UPDATE_USER_POINT } from "./actionTypes";
// Update 6/9/2025: All actions now update contact_quota as unified currency
export const USER_ACTIONS = {
  updateUserContactQuote: "UPDATE_USER_CONTACT_QUOTE",
  updateUserCreditChat: "UPDATE_USER_CREDIT_CHAT", // Now updates contact_quota
  reloadContactCredit: "RELOAD_CONTACT_CREDIT",
};

export const setUser = (data: any) => {
  return {
    type: SET_USER,
    payload: data,
  };
};

// Updates contact_quota (unified currency)
export const updateUserPoint = (point?: number) => {
  return {
    type: UPDATE_USER_POINT,
    payload: point,
  };
};

// Updates contact_quota
export const updateUserContactQuote = (point?: string) => {
  return {
    type: USER_ACTIONS.updateUserContactQuote,
    payload: point,
  };
};

// Updates contact_quota (not conversation_quota anymore)
export const updateUserCreditChat = (point?: string) => {
  return {
    type: USER_ACTIONS.updateUserCreditChat,
    payload: point,
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  };
};

export const onReloadContactCredit = () => {
  return {
    type: USER_ACTIONS.reloadContactCredit,
  };
};
